import { Brand } from './Brand';

export const defaultBrand = 'jucy';

export const brands: Brand[] = ['jucy', 'star'];
